import { Component, OnInit } from '@angular/core';

import { AbstractComponentWithScrollContainer } from 'src/app/shared/components/abstract-component-with-scroll-container';
import { BasicService } from 'src/app/shared/services/basic.service';
import { ScrollService } from 'src/app/shared/services/scroll.service';
import { GiphyApiService } from './giphy-api.service';
import { GiphySearchResult } from './model';

@Component({
  selector: 'app-gif-search-modal',
  templateUrl: './gif-search-modal.component.html',
  styleUrls: ['./gif-search-modal.component.scss'],
})
export class GifSearchModalComponent extends AbstractComponentWithScrollContainer implements OnInit {
  availableGifs = []; // All gifs returned by the api call
  filteredGifs = []; // Displayed in the UI

  infiniteScrollEvent: any;

  constructor(
    private basicService: BasicService,
    private scrollService: ScrollService,
    private giphyApiService: GiphyApiService
  ) {
    super();
  }

  ngOnInit() {
    // Initially display trending gifs
    this.giphyApiService.fetchTrendingGifs().subscribe(res => this.processResponse(res));
  }

  dismissModal() {
    this.basicService.dismissModal();
  }

  onGifClick(gif) {
    this.basicService.dismissModal(gif);
  }

  // Fetch gifs according to search input
  onSearchInputChange($event) {
    const searchText = $event.target.value.toLowerCase();

    if (searchText === '') {
      this.giphyApiService.fetchTrendingGifs().subscribe(res => this.processResponse(res));
    } else {
      this.giphyApiService.fetchGifsBySearchInput(searchText).subscribe(res => this.processResponse(res));
    }

    // Reenable infinite scroll and scroll to top
    if (this.infiniteScrollEvent) {
      this.infiniteScrollEvent.target.disabled = false;
    }
    this.scrollService.scrollToTop(this);
  }

  loadMoreGifs($event) {
    // Load the next 10 gifs
    this.filteredGifs.push(...this.availableGifs.slice(this.filteredGifs.length, this.filteredGifs.length + 10));
    $event.target.complete();

    // If all gifs are loaded disable infinite scroll
    if (this.filteredGifs.length === this.availableGifs.length) {
      this.infiniteScrollEvent = $event;
      $event.target.disabled = true;
    }
  }

  processResponse(res: GiphySearchResult) {
    this.availableGifs = res.data;
    this.filteredGifs = this.availableGifs.slice(0, 10); // Then display just the first 10 in the UI
  }
}
